export default __webpack_public_path__ + "assets/images/79dc9039a47bf7c232eda9bf83f2fa47.svg";